/**
 * Handles onKeyDown event for the number inputs
 * Prevents arrow up & down
 *
 * @param e
 */
export const preventArrowUpAndDownEvent = (e): void => {
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault()
}

/**
 * Handles onWheel event for the number inputs
 * Prevents scroll
 *
 * @param e
 */
export const preventInputScrollEvent = (e): void => {
  e.currentTarget.blur()
}

/**
 * Prevents special characters
 *
 * @param e
 */
export const preventSpecialCharachtersEvent = (e): void => {
  if (!/^[a-zA-Z0-9]/.test(e.key) || /^[ \-/.]/.test(e.key)) e.preventDefault()
}
